<script setup lang="ts">
import { defineProps, defineEmits } from "vue";
import CheckIcon from "@/components/icons/CheckIcon.vue";

defineProps({
  inputId: {
    type: String,
  },
  isEnabled: {
    type: Boolean,
    default: false,
  },
  isDisabled: {
    type: Boolean,
    default: false,
  },
  label: {
    type: String,
  },
});

const emit = defineEmits(["toggle"]);
</script>

<template>
  <label
    class="relative w-full flex items-center"
    :class="isDisabled ? 'opacity-60' : 'cursor-pointer'"
  >
    <input
      type="checkbox"
      class="peer appearance-none min-w-6 min-h-6 rounded border border-ternary bg-secondary checked:bg-active checked:border-active"
      :class="{ 'cursor-pointer': !isDisabled }"
      :checked="isEnabled"
      :disabled="isDisabled"
      @change="emit('toggle')"
    />
    <CheckIcon
      class="absolute opacity-0 peer-checked:opacity-100 pointer-events-none ml-1"
    />
    <slot name="label" :label="label">
      <span class="block text-left font-normal text-sm text-brown ml-2">
        {{ label }}
      </span>
    </slot>
  </label>
</template>
